export default __webpack_public_path__ + "static/media/tableau.8ca70ca9.svg";